import styled from "styled-components";

export const LinkRoot = styled.a`
    display: flex;
    text-decoration: none;
    font-weight: 600;

    &:hover {
        opacity: 0.8;
    }
`;
